import React, { useState, useEffect } from "react";
import {
  Breadcrumb,
  BreadcrumbItem,
  Row,
  Col,
  Card,
  CardBody,
  CardTitle,
} from "reactstrap";
import toast, { Toaster } from "react-hot-toast";
import { TextField } from "@material-ui/core";
import { Autocomplete } from "@material-ui/lab";
import { useAuth0, withAuthenticationRequired } from "@auth0/auth0-react";

//Componentes
import ModalCreacion from "./componentes/modalCreacionProceso";
import ModalExportacionAPE from "./componentes/modalExportacionAPE";
import CrearSolicitudButton from "../../components/buttons/crearSolicitudButton";
import DownloadTableButton from "../../components/buttons/downloadTableButton";
import Loading from "../../components/modales/loadingModal";
import LoadingTransparent from "../../components/modales/loadingModalTransparent";
import ListadoAPE from "../../components/lists/ListadoAPE";
import { useNavigate } from "react-router-dom";

//Redux
import { connect } from "react-redux";

//Funciones
import { downloadInformeAPE } from "./utils/downloadInformeAPE";
import { userRolValidation } from "../../utils/userValidation/rolValidation";
import {
  useCrearApeHabilitado,
  avisoCreacionEnSysConfi,
} from "../../utils/flags/creacionApe";

//GCP Functions
import { functionsHttpsCallable } from "../../utils/FirebaseStorage/firebase";

//API Calls
const listadoAPEActual = functionsHttpsCallable("ape_listadoHistorico");

//Info usuario en Reducer
const mapStateToProps = (state) => ({
  usuarioActivo: state,
});

//Toast
const toastSuccess = (msg) => toast.success(msg);
const toastError = (msg) => toast.error(msg);

let ListadoHistorial = (props) => {
  const navigate = useNavigate();
  const { isAuthenticated } = useAuth0();
  const [userData] = useState(
    isAuthenticated ? JSON.parse(localStorage.getItem("userData")) : []
  );
  const [campoConsulta, setCampoConsulta] = useState("");
  const [campoBusqueda, setCampoBusqueda] = useState("");
  const [campo, setCampo] = useState("");
  const [data, setData] = useState([]);
  const [dataModal] = useState([]);
  const [loading, setLoading] = useState(true);
  const [modal, setModal] = useState(false);
  const [modalExportacionAPE, setModalExportacionAPE] = useState(false);
  const [modalTransaction, setModalTransaction] = useState(false);
  const [permisos, setPermisos] = useState({
    creacion: false,
    descargaAPE: false,
  });
  const [solicitudes, setSolicitudes] = useState([]);
  const [solicitudesVisualizar, setSolicitudesVisualizar] = useState([]);
  const [userId] = useState(parseInt(userData.userId));

  // Mismo flag que menuOperaciones: el campo `crearAPE` de la empresa, no el código.
  const { habilitado: creacionHabilitada } = useCrearApeHabilitado(userData.codigoEmpresa);

  useEffect(() => {
    if (!isAuthenticated) {
      navigate("/login");
    }
    let permisosTemp = getPermissions();
    setPermisos(permisosTemp);
    async function getData() {
      await getDataSolicitudes();
    }
    getData();
    document.title = "Solicitudes de APE";
  }, []);

  useEffect(() => {
    handleBusqueda();
  }, [campoBusqueda]);

  //Toast
  const toastSuccess = (msg) => toast.info(msg, { autoClose: 3000 });

  const toastError = (msg) => toast.error(msg, { autoClose: 3000 });

  //Funciones varias
  const addNuevaSolicitud = (solicitud) => {
    let oldData = data;
    oldData.push(solicitud);
    setData(oldData);
  };

  const getPermissions = () => {
    let rolesCreacion = ["administrador", "aprobador", "creador"];
    let rolesDescargaAPE = ["administrador", "aprobador", "creador"];
    let validacion = {
      creacion: userRolValidation(rolesCreacion, userData),
      descargaAPE: userRolValidation(rolesDescargaAPE, userData),
    };
    return validacion;
  };

  const downloadInfoAPE = async (body) => {
    setModalTransaction(true);
    await downloadInformeAPE(body);
    setModalTransaction(false);
  };

  const getDataSolicitudes = async () => {
    try {
      let body = {
        userId: userId,
        cod_empr: userData.codigoEmpresa,
      };
      let dataSolicitudesActuales = await listadoAPEActual(body);
      setSolicitudes(formatListado(dataSolicitudesActuales.data.data));
      setSolicitudesVisualizar(formatListado(dataSolicitudesActuales.data.data));
    } catch (e) {
      console.log("error", e);
    }
    setLoading(false);
  };

  const formatListado = (listado) => {
      console.log("listado", listado);
      const newList = [];
    listado.forEach((item) => {
      newList.push({
        id: item.solicitudId,
        cargo: item.codigoCargo,
        color: "info",
        estado: item.estadoAPE,
        campo: item.campo,
        creador: item.cedulaCreador,
        responsable: item.codigoActual,
        cliente: item.clienteComercial,
        name: getNombreActual(item),
        perteneceGrupo: item.perteneceGrupo,
        grupo: item.grupo ?? [],
      });
    });
    console.log("newList", newList)
    return newList;
  };

  const getNombreActual = (data) => {
    switch (data.estadoAPE) {
      case "APROBACION2":
        return data.nombreSegundoAprobador;
      case "APROBACION3":
        return data.nombreTercerAprobador;
      case "APROBACION4":
        return data.nombreCuartoAprobador;
      case "RECLUTADOR":
        return data.nombreReclutador;
      case "CONTRATACION":
        return data.nombreContratador;
      case "APROBACION1":
      default:
        return data.nombrePrimerAprobador;
    }
  };

  const handleBusqueda = () => {
    let solicitudesPropiasTemp;
    if (campoBusqueda !== "" && campoBusqueda !== undefined) {
      if (campo === "cargo" || campo === "id") {
        if (solicitudes.length > 0) {
          solicitudesPropiasTemp = solicitudes.filter((solicitud) =>
            solicitud[campo].toString().includes(campoBusqueda.toUpperCase())
          );
        }
      } else {
        solicitudesPropiasTemp = solicitudes;
      }
    } else {
      solicitudesPropiasTemp = solicitudes;
    }
    setSolicitudesVisualizar(solicitudesPropiasTemp);
  };

  const renderModalCreacion = () => {
    // Con la creación cerrada el modal no se monta, así que la callable
    // ape_crearSolicitudEmpleo queda sin quien la invoque.
    if (!creacionHabilitada) {
      return null;
    }
    return (
      <ModalCreacion
        toggle={() => {
          toggle();
        }}
        modal={modal}
        setLoading={(e) => {
          setLoading(e);
        }}
        setCampoConsulta={(e) => {
          setCampoConsulta(e);
        }}
        setModalTransaction={(e) => {
          setModalTransaction(e);
        }}
        addSolicitud={(e) => {
          addNuevaSolicitud(e);
        }}
        data={dataModal}
      />
    );
  };

  const renderModalExportacion = () => {
    return (
      <ModalExportacionAPE
        toggle={() => {
          toggleExportacionAPE();
        }}
        modal={modalExportacionAPE}
        toastSuccess={toastSuccess}
        toastError={toastError}
        data={dataModal}
        action={(e) => downloadInfoAPE(e)}
      />
    );
  };

  //Toggles
  const toggle = () => setModal(!modal);
  const toggleTransaction = () => setModalTransaction(!modalTransaction);
  const toggleExportacionAPE = () =>
    setModalExportacionAPE(!modalExportacionAPE);

  return loading ? (
    <div className={"loading-area"}>
      <Loading />
    </div>
  ) : (
    <>
      <Toaster />
      <LoadingTransparent isOpen={modalTransaction} />
      {renderModalCreacion()}
      {renderModalExportacion()}
      <Breadcrumb>
        <BreadcrumbItem className="breadcum-display-content" active>
          Resumen de Solicitudes
          {permisos.descargaAPE ? (
            <DownloadTableButton
              onClick={() => {
                toggleExportacionAPE();
              }}
            />
          ) : null}
        </BreadcrumbItem>
      </Breadcrumb>
      {/* <Breadcrumb>
                <BreadcrumbItem className='breadcum-display-content' active>
                    Creadas por mi
                    {permisos.creacion ? <CrearSolicitudButton
                        onClick={() => { toggle() }}
                    /> : null}
                </BreadcrumbItem>
            </Breadcrumb> */}
      <Card>
        <CardBody>
          <CardTitle tag="h5">
            <div className="aproaciones-card-title">
              Historico Solicitudes de Empleo
              {permisos.creacion ? (
                <CrearSolicitudButton
                  onClick={() => {
                    // El botón se queda en su sitio incluso con la creación
                    // cerrada, para que no se lea como un sistema roto.
                    if (creacionHabilitada) {
                      toggle();
                    } else {
                      avisoCreacionEnSysConfi();
                    }
                  }}
                />
              ) : null}
            </div>
          </CardTitle>
        </CardBody>
        <CardBody>
          <Row>
            <Col lg="10" md="8" xs="12">
              <TextField
                required
                autoComplete="off"
                key={`key_busqueda`}
                id={`input_busqueda`}
                fullWidth
                label={"Busqueda"}
                onChange={(e) => setCampoBusqueda(e.target.value)}
                defaultValue=""
                margin="normal"
              />
            </Col>
            <Col lg="2" md="4" xs="12">
              <Autocomplete
                required
                margin="dense"
                options={[
                  { label: "Numero APE", value: "id" },
                  { label: "Cargo", value: "cargo" },
                ]}
                key={`key_Cargo`}
                id={`select_Cargo`}
                onChange={(event, newValue) => {
                  if (newValue) {
                    setCampo(newValue.value);
                  } else {
                    setCampo(undefined);
                    setSolicitudesVisualizar([...data]);
                  }
                }}
                renderInput={(params) => (
                  <TextField {...params} label={"Campo"} margin="normal" />
                )}
                getOptionLabel={(option) => option.label}
                renderOption={(option) => (
                  <React.Fragment>{option.label}</React.Fragment>
                )}
              />
            </Col>
          </Row>
          <ListadoAPE
            listaSolicitudes={solicitudesVisualizar}
            linkTo={"/home/historico/solicitud/"}
          />
        </CardBody>
      </Card>
      <br />
    </>
  );
};

export default withAuthenticationRequired(
  connect(mapStateToProps)(ListadoHistorial),
  {
    onRedirecting: () => <Loading />,
  }
);
